import { createApp } from 'vue'
import { getVotedArticle, vote } from '~/js/helpers/contest-helper'
import { getArticlesByBlogId } from '~/js/helpers/storefront-api-helper'
const ID_BLOG_CONTEST = 'js-blog-contest'

document.addEventListener('DOMContentLoaded', async () => {
  const elementBlogContest = document.getElementById(ID_BLOG_CONTEST)
  if (!elementBlogContest) return

  const { blogId, datetimeStart, datetimeEnd } = elementBlogContest.dataset

  // 開催ステータスを判定: 'before' | 'active' | 'ended'
  const now = Date.now()
  const startTime = new Date(datetimeStart.replace(' ', 'T')).getTime()
  const endTime = new Date(datetimeEnd.replace(' ', 'T')).getTime()
  const contestStatus =
    now < startTime ? 'before' : now > endTime ? 'ended' : 'active'

  const articles = (await getArticlesByBlogId(blogId)).sort(
    () => Math.random() - 0.5
  )

  const { votedArticleId } = await getVotedArticle()

  createApp({
    name: 'TemplatesBlogContest',
    data() {
      return {
        articles,
        votedArticleId,
        isProcessing: false,
      }
    },
    computed: {
      isButtonDisabled() {
        return (
          contestStatus !== 'active' ||
          !!this.votedArticleId ||
          this.isProcessing ||
          undefined
        )
      },
    },
    methods: {
      buttonText(article) {
        if (article.id == this.votedArticleId) return '投票済み'
        if (contestStatus === 'active') return '投票する'
        if (contestStatus === 'ended') return '投票終了'
      },
      async onButtonVoteClicked(id) {
        if (this.isButtonDisabled) return
        if (!confirm('このコーディネートに投票します。よろしいですか？')) return
        this.isProcessing = true
        try {
          const articleId = await vote(id)
          this.votedArticleId = articleId
        } catch (error) {
          console.error(error)
        }
        this.isProcessing = false
      },
    },
  }).mount(elementBlogContest)
})
